<div class="container">
  <div class="row">
    <div class="col-12 col-lg-8 offset-lg-2 px-sm-3 mt-2">
      <div class="cmp-input-search">
        <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
          <div class="input-group">
            <label for="autocomplete-autocomplete-three" class="visually-hidden"
              >Cerca nel sito</label
            >
            <input
              type="search"
              class="autocomplete form-control"
              placeholder="Cerca"
              id="autocomplete-autocomplete-three"
              name="autocomplete-three"
              [(ngModel)]="searchTerm"
              data-bs-autocomplete="[]"
              (keydown)="onEnterPressed($event)"
            />
            <div class="input-group-append">
              <button
                class="btn btn-primary"
                type="button"
                id="button"
                (click)="search(searchTerm)"
              >
                Invio
              </button>
            </div>

            <span class="autocomplete-icon" aria-hidden="true">
              <svg
                class="icon icon-sm icon-primary"
                aria-label="Cerca nel sito"
              >
                <use
                  href="bootstrap-italia/dist/svg/sprites.svg#it-search"
                ></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="row pt-2 pb-4">
    <div class="col-12 col-lg-8 offset-lg-2 px-0 px-sm-3">
      <div class="cmp-accordion faq">
        <div class="accordion" id="accordion-faq">
          <ng-container *ngFor="let faq of faqList; let i = index">
            <div class="accordion-item">
              <div class="accordion-header" id="headingfaq-{{ i + 1 }}">
                <button
                  class="accordion-button collapsed title-snall-semi-bold py-3"
                  type="button"
                  data-bs-toggle="collapse"
                  attr.data-bs-target="#collapsefaq-{{ i + 1 }}"
                  aria-expanded="true"
                  attr.aria-controls="collapsefaq-{{ i + 1 }}"
                >
                  <div class="button-wrapper">
                    {{ faq.title }}
                  </div>
                </button>
              </div>

              <div
                id="collapsefaq-{{ i + 1 }}"
                class="accordion-collapse collapse p-0"
                attr.data-bs-parent="#accordionExamplefaq-{{ i + 1 }}"
                role="region"
                attr.aria-labelledby="headingfaq-{{ i + 1 }}"
              >
                <div class="accordion-body">
                  <p class="mb-3" [innerHTML]="faq.faq_body?.processed"></p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-8 offset-lg-2 px-4" *ngIf="hasMore">
      <button
        type="button"
        class="btn btn-outline-primary w-100 mt-40 mb-40 title-medium-bold"
        data-focus-mouse="false"
        (click)="loadMore()"
      >
        <span class="">Carica altre domande</span>
      </button>
    </div>
  </div>
</div>
